/**
 * Returns config without any modifications
 * @param {Config} config
 * @returns {Config}
 */
export default config => config;
